import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Music } from "lucide-react";

export default function AudioPlayer({ path, filename, className = "" }) {
  const [src, setSrc] = useState(null);
  const [label, setLabel] = useState(filename || "Audio");

  useEffect(() => {
    if (!path) return undefined;
    let revoke;
    let cancelled = false;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => {
        if (cancelled) return;
        const url = URL.createObjectURL(r.data);
        revoke = url;
        setSrc(url);
      })
      .catch((e) => console.error("audio load failed", e));
    if (!filename) {
      api.get(`/files-meta/${path}`)
        .then((r) => { if (!cancelled && r.data?.filename) setLabel(r.data.filename); })
        .catch(() => {});
    }
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path, filename]);

  return (
    <div className={`jj-card !rounded-xl p-4 ${className}`} data-testid={`audio-${path}`}>
      <div className="flex items-center gap-3 mb-3">
        <div className="h-10 w-10 rounded-lg bg-burgundy text-cream flex items-center justify-center shrink-0">
          <Music className="h-5 w-5" strokeWidth={1.6} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-jjblue truncate">{label}</div>
          <div className="text-xs text-[var(--jj-muted)]">Worship · inspiration</div>
        </div>
      </div>
      {src ? (
        <audio src={src} controls preload="metadata" className="w-full" />
      ) : (
        <div className="h-10 bg-cream-surface rounded-md animate-pulse" />
      )}
    </div>
  );
}
